import { IconAlertTriangle } from '@iwoca/icons';
import { AlertBox } from '@iwoca/orion';

export const OverdueBanner = () => {
  return (
    <AlertBox
      variant="failure"
      className="mb-l flex flex-col items-start gap-m !bg-structure-100 !p-l"
    >
      <div className="flex items-center gap-s">
        <IconAlertTriangle className="h-[20px] w-[20px] fill-[#FB5950]" />
        <p className="m-0 text-xl font-bold">You have some overdue payments</p>
      </div>
      <p className="m-0 text-m font-med">
        You'll need to settle any overdue payments before you can spread the
        cost of a new one.
      </p>
    </AlertBox>
  );
};
